import React from 'react';
import {
  ControlLabel,
  FormControl,
  FormGroup,
  HelpBlock,
} from 'react-bootstrap';

const FormFieldLayout = ({
  children,
  componentClass: Component = FormGroup,
  label,
  validationIcon,
  validationMessage,
  ...props
}) => (
  <Component {...props}>
    {
      label
        ? <ControlLabel>{label}</ControlLabel>
        : null
    }
    {children}
    {
      validationIcon
        ? <FormControl.Feedback>{validationIcon}</FormControl.Feedback>
        : null
    }
    {
      validationMessage
        ? <HelpBlock>{validationMessage}</HelpBlock>
        : null
    }
  </Component>
);

export default FormFieldLayout;
